// eslint-disable-next-line node/no-unpublished-import
import {action} from 'typesafe-actions';
import {UserFlowMapKeys} from '../../Facade/UserFlow/UserFlowFacade';

export enum AppActionTypes {
  SET_IS_LOADED = 'SET_IS_LOADED',
  SET_USERFLOW_STAGE = 'SET_USERFLOW_STAGE',
  SET_CALENDAR_DATA = 'SET_CALENDAR_DATA',
}

export const AppActions = {
  setIsLoaded: (isLoaded: boolean) => action(AppActionTypes.SET_IS_LOADED, isLoaded),
  setUserFlowStage: (userFlowStage: UserFlowMapKeys) =>
    action(AppActionTypes.SET_USERFLOW_STAGE, userFlowStage),
  setCalendarData: (calendarData: any) => action(AppActionTypes.SET_CALENDAR_DATA, calendarData),
};
